import { AppRouter } from './app/AppRouter';

export default function App() {
  return <AppRouter />;
}


